import {Link} from "react-router-dom";
import {isNullOrUndefined} from "../../../services/Validator";

export default function HomeFooterNavigationItem({item}) {
    // Used in HomeFooterMainNavigationList to display
    // one single navigation item

    // BUILD
    if (isNullOrUndefined(item))
        return null
    return (
        <Link to={item.link.pathname}
            state={item.link.state}
            className={"font-normal text-[16px] text-backgroundLight5 hover:text-backgroundLight1"}>
            {item.text}
        </Link>
    )
}